module.exports = __webpack_public_path__ + "static/media/YQ.d1ad13aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/invitation/index/image/YQ.png
// module id = 960
// module chunks = 0